import { html, render } from 'lit-html'
import styles from './header.css'

export class JackTest extends HTMLElement {
  shadow: ShadowRoot

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
  }

  connectedCallback(): void {
    this.render()
  }

  render(): void {
    const template = html`
      <style>
        ${styles}
      </style>
      <div>
        <h1>Jack Text</h1>
        <p>Some text here</p>
      </div>
    `
    render(template, this.shadow, { host: this })
  }
}

customElements.define('jack-test', JackTest)
